























import $ from 'jquery';
import { addClass, removeClass, hasClass } from '@/utils/jsHelpers';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
	name: 'AccordionItem',
})
export default class AccordionItem extends Vue {
	@Prop() private item: any;
	@Prop() private itemIndex: any;
	@Prop() private showFooter: boolean;
	@Prop() private openAccordion: boolean;
	@Prop() private toggleCustomAccordion: (status: string) => unknown;

	private uniqueId: string;
	private uniqueIndex: number;
	private created() {
		this.uniqueId = `accordion-unique-id-${this.itemIndex}`;
	}

	@Watch('openAccordion')
	private watchOpenAccordion() {
		if (this.openAccordion) {
			this.toggleAccordion();
		}
	}

	private toggleAccordion() {
		if (!hasClass(document.querySelector(`#${this.uniqueId}`), 'is-closed')) {
			addClass(document.querySelector(`#${this.uniqueId}`), 'is-closed');

			if (this.toggleCustomAccordion !== undefined) {
				this.toggleCustomAccordion('closed');
			}
		} else {
			removeClass(document.querySelector(`#${this.uniqueId}`), 'is-closed');
			if (this.toggleCustomAccordion !== undefined) {
				this.toggleCustomAccordion('open');
			}
		}
	}
}
